/**
 * Users (Activity Users) Column Definitions
 * Compulsory: Distinct ID
 * Max 7 columns at any given time
 * Defaults are agent activity (every backend-SDK team has it); the browser
 * SDK's visit, location and device columns stay available.
 */

export const MAX_COLUMNS = 7;

export const AVAILABLE_COLUMNS = {
  distinct_id: {
    label: 'User',
    field: 'distinctId',
    category: 'core',
    default: true,
    required: true
  },
  last_active: {
    label: 'Last Active',
    field: 'lastActiveAt',
    category: 'agents',
    formatter: 'relativeTime',
    default: true
  },
  agent_runs: {
    label: 'Runs',
    field: 'agentRuns',
    category: 'agents',
    align: 'right',
    default: true
  },
  agent_errors: {
    label: 'Errors',
    field: 'agentErrors',
    category: 'agents',
    align: 'right',
    default: true
  },
  agent_cost: {
    label: 'Cost',
    field: 'agentCost',
    category: 'agents',
    align: 'right',
    default: true
  },
  agents: {
    label: 'Agents',
    field: 'agents',
    category: 'agents',
    default: true
  },
  first_visit: {
    label: 'First Visit',
    field: 'firstVisit',
    category: 'core',
    formatter: 'relativeTime',
    default: false
  },
  last_visit_time: {
    label: 'Last Visit',
    field: 'lastVisitTime',
    category: 'core',
    formatter: 'relativeTime',
    default: false
  },
  total_page_views: {
    label: 'Total Page Views',
    field: 'totalPageViews',
    category: 'activity',
    default: false
  },
  total_time_spent: {
    label: 'Total Time Spent',
    field: 'totalTimeSpent',
    category: 'activity',
    formatter: 'duration',
    default: false
  },
  first_referrer: {
    label: 'First Referrer',
    field: 'firstReferrer',
    category: 'session',
    default: false
  },
  last_referrer: {
    label: 'Last Referrer',
    field: 'lastReferrer',
    category: 'session',
    default: false
  },
  first_location_city: {
    label: 'First Location City',
    field: 'firstLocationCity',
    category: 'location',
    default: false
  },
  first_location_country: {
    label: 'First Location Country',
    field: 'firstLocationCountry',
    category: 'location',
    default: false
  },
  last_location_city: {
    label: 'Last Location City',
    field: 'lastLocationCity',
    category: 'location',
    default: false
  },
  last_location_country: {
    label: 'Last Location Country',
    field: 'lastLocationCountry',
    category: 'location',
    default: false
  },
  device_type: {
    label: 'Device Type',
    field: 'deviceType',
    category: 'device',
    default: false
  },
  browser_name: {
    label: 'Browser Name',
    field: 'browserName',
    category: 'device',
    default: false
  },
  os: {
    label: 'OS',
    field: 'os',
    category: 'device',
    default: false
  },
  is_bounce: {
    label: 'Is Bounce',
    field: 'isBounce',
    category: 'identity',
    default: false
  },
  is_web3_user: {
    label: 'Is Web3 User',
    field: 'isWeb3User',
    category: 'identity',
    default: false
  },
  primary_wallet_address: {
    label: 'Primary Wallet Address',
    field: 'primaryWalletAddress',
    category: 'wallet',
    default: false
  },
  wallet_networth: {
    label: 'Wallet Networth',
    field: 'networthUsd',
    category: 'wallet',
    formatter: 'currency',
    default: false
  }
};

export const DEFAULT_COLUMNS = {
  enabled: ['distinct_id', 'last_active', 'agent_runs', 'agent_errors', 'agent_cost', 'agents'],
  order: ['distinct_id', 'last_active', 'agent_runs', 'agent_errors', 'agent_cost', 'agents']
};

export const COLUMN_CATEGORIES = {
  core: 'Core',
  agents: 'Agents',
  session: 'Session',
  location: 'Location',
  activity: 'Activity',
  device: 'Device',
  identity: 'Identity',
  wallet: 'Wallet'
};

export const getColumnDefinition = (columnKey) => {
  return AVAILABLE_COLUMNS[columnKey] || null;
};

export const getAvailableColumnKeys = () => {
  return Object.keys(AVAILABLE_COLUMNS);
};
